import ScrollReveal from '@/components/effects/ScrollReveal';
import { useLang } from '@/contexts/LanguageContext';

export default function Terms() {
  const { lang } = useLang();
  const isAr = lang === 'ar';

  return (
    <div data-testid="terms-page" className="min-h-screen py-20 md:py-32 px-4">
      <div className="max-w-3xl mx-auto">
        <ScrollReveal>
          <h1 className="text-4xl sm:text-5xl font-display text-heading mb-8">
            {isAr ? 'شروط الخدمة' : 'Terms of Service'}
          </h1>
          <p className="text-text-muted text-sm font-body mb-12">
            {isAr ? 'آخر تحديث: أبريل 2026' : 'Last updated: April 2026'}
          </p>
        </ScrollReveal>

        <div className="prose-gravity font-body space-y-8">
          <ScrollReveal delay={0.05}>
            <section>
              <h2>{isAr ? 'القبول' : 'Acceptance'}</h2>
              <p>{isAr
                ? 'باستخدام tariqwithin.com، فإنك توافق على هذه الشروط. إذا لم توافق، يرجى عدم استخدام الموقع.'
                : 'By using tariqwithin.com, you agree to these terms. If you do not agree, please do not use the site.'
              }</p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.1}>
            <section>
              <h2>{isAr ? 'الحسابات' : 'Accounts'}</h2>
              <p>{isAr
                ? 'أنت مسؤول عن الحفاظ على أمان حسابك. يجب أن تكون المعلومات المقدمة دقيقة. نحتفظ بالحق في تعليق الحسابات التي تنتهك هذه الشروط.'
                : 'You are responsible for maintaining the security of your account. Information provided must be accurate. We reserve the right to suspend accounts that violate these terms.'
              }</p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.15}>
            <section>
              <h2>{isAr ? 'المشتريات والمبالغ المستردة' : 'Purchases & Refunds'}</h2>
              <p>{isAr
                ? 'جميع المبيعات الرقمية (الكتب الإلكترونية، الدورات) نهائية ما لم يتم ذكر خلاف ذلك. للمنتجات المادية، يرجى التواصل معنا خلال 14 يوماً للاستبدال.'
                : 'All digital sales (eBooks, courses) are final unless otherwise stated. For physical products, please contact us within 14 days for exchanges.'
              }</p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.2}>
            <section>
              <h2>{isAr ? 'الملكية الفكرية' : 'Intellectual Property'}</h2>
              <p>{isAr
                ? 'جميع المحتويات على هذا الموقع — بما في ذلك النصوص والصور والتصميم والكتب — هي ملكية فكرية لطارق أبو فياض. لا يجوز إعادة إنتاجها أو توزيعها دون إذن كتابي.'
                : 'All content on this site — including text, images, design, and books — is the intellectual property of Tariq AbuFiad. Reproduction or distribution without written permission is prohibited.'
              }</p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.25}>
            <section>
              <h2>{isAr ? 'سلوك المستخدم' : 'User Conduct'}</h2>
              <p>{isAr
                ? 'في المنتدى وأقسام التعليقات، نتوقع منك الاحترام والنزاهة. يُحظر المحتوى المسيء أو العنيف أو المضايقة. نحتفظ بالحق في إزالة المحتوى المخالف.'
                : 'In the forum and comment sections, we expect respect and integrity. Abusive, violent, or harassing content is prohibited. We reserve the right to remove violating content.'
              }</p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.3}>
            <section>
              <h2>{isAr ? 'تقييد المسؤولية' : 'Limitation of Liability'}</h2>
              <p>{isAr
                ? 'يتم تقديم المحتوى التعليمي والنصائح للأغراض الإعلامية فقط. لا نتحمل المسؤولية عن النتائج الناجمة عن تطبيق أي نصيحة مقدمة على المنصة.'
                : 'Educational content and advice are provided for informational purposes only. We are not liable for outcomes resulting from applying any advice provided on the platform.'
              }</p>
            </section>
          </ScrollReveal>

          <ScrollReveal delay={0.35}>
            <section>
              <h2>{isAr ? 'اتصل بنا' : 'Contact'}</h2>
              <p>{isAr
                ? 'لأي أسئلة حول هذه الشروط:'
                : 'For any questions about these terms:'
              }</p>
              <p><a href="mailto:contact@tariqwithin.com">contact@tariqwithin.com</a></p>
            </section>
          </ScrollReveal>
        </div>
      </div>
    </div>
  );
}
